import { jsx as _jsx } from "react/jsx-runtime";
export const StatusBadge = ({ status, label }) => {
    const statusConfig = {
        ACTIVE: {
            color: 'bg-green-100 text-green-800 border-green-200',
            label: 'Active',
        },
        SUSPENDED: {
            color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
            label: 'Suspended',
        },
        BANNED: {
            color: 'bg-red-100 text-red-800 border-red-200',
            label: 'Banned',
        },
        active: {
            color: 'bg-green-100 text-green-800 border-green-200',
            label: 'Active',
        },
        suspended: {
            color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
            label: 'Suspended',
        },
        banned: {
            color: 'bg-red-100 text-red-800 border-red-200',
            label: 'Banned',
        },
        inactive: {
            color: 'bg-gray-100 text-gray-800 border-gray-200',
            label: 'Inactive',
        },
        warning: {
            color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
            label: 'Warning',
        },
        error: {
            color: 'bg-red-100 text-red-800 border-red-200',
            label: 'Error',
        },
        open: {
            color: 'bg-green-100 text-green-800 border-green-200',
            label: 'Open',
        },
        closed: {
            color: 'bg-purple-100 text-purple-800 border-purple-200',
            label: 'Closed',
        },
    };
    const config = statusConfig[status];
    return (_jsx("span", { className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.color}`, children: label || config.label }));
};
